import { DATE_FORMAT } from "@/constants/datetime";
import { text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { spacing } from "@/theme/variables";
import { dayjs } from "@/utils/dayjs";
import { Box, css, Stack, styled, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { stripHtml } from "@/utils/string";
import { textEllipsis } from "@/theme/minxin";
import { TGetInformationListDto } from "@/api/services/main/information/dtos/get-information-list.dto";

export type TNotificationCardModalProps = {
  data: TGetInformationListDto,
};

export const NotificationCardModal: FC<TNotificationCardModalProps> = ({ data }) => {
  const content = useMemo(() => {
    return (
      <Stack gap={1}>
        <Box
          sx={{
            width: "100%",
            display: "block",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {stripHtml(data.content)}
        </Box>
      </Stack>
    );
  }, [data.content]);

  return (
    <Stack gap={1} p={2}>
      <BoxWrapper>
        <Typography variant="sub16Semi" fontWeight={700}>
          {dayjs(data.startDate).format(DATE_FORMAT)}
        </Typography>
        {data.informationReads.length === 0 &&
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              bgcolor: text.noti,
              flexShrink: 0,
            }}
          />
        }
      </BoxWrapper>
      <Stack>
        <Typography
          variant="head20Bold"
          flex={1}
          sx={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {data.title}
        </Typography>
      </Stack>
      <ContentBox>{content}</ContentBox>
    </Stack>
  );
};

const BoxWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${spacing.sm};
`;

const ContentBox = styled(Box)`
  ${css(typography.body14)};
  max-height: 80px;
  ${css(textEllipsis)}
`;
